import type { UserType } from '~/model/UserType';
import { useFormatter, useTranslations } from 'next-intl';
import { Avatar } from '~/components/commons/Avatar/Avatar';
import appConst from '~/const/appConst';

export interface AuthorPropsType {
  user: UserType;
  htmlId?: string;
  beginDate?: string;
}

export const Author = ({ user, htmlId, beginDate = null }: AuthorPropsType) => {
  const t = useTranslations('INTERACTION');
  const format = useFormatter();
  const { firstname = null } = user || {};
  return (
    <div id={htmlId} className="author" data-testid="author">
      <span className="author__avatar">
        <Avatar user={user} ariaHidden />
      </span>
      <div className="author__content">
        <span className="vp-subtitle-m">{firstname}</span>
        {beginDate && (
          <span className="author__date">
            {t('DATE', {
              beginDateDay: format.dateTime(new Date(beginDate), {
                ...appConst.dateFormat.dateWithMonthLong,
              }),
            })}
          </span>
        )}
      </div>
    </div>
  );
};
